import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/blue-isometric-technological-city_23-2147557935.jpg';

function DigitalTransformation() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Digital Transformation and Smart City Projects" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Digital Transformation and Smart City Projects</h4>
              <p>
                This sub-department focuses on modernizing city services and infrastructure through innovative technology.<br />
                Initiatives include smart city projects, e-governance systems, and the integration of IoT for efficient public services.<br /><br />
                Our goal is to create sustainable and technologically advanced communities that improve the quality of life for all residents.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Smart City Infrastructure Development</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Integration of IoT in Public Services</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Advancing E-Governance Solutions</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to driving innovation in public services, ensuring sustainable development, and enhancing the livability of our cities through cutting-edge technology.
              </p>
            </div>
            <div>
              <Link to="/department/technology">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default DigitalTransformation;
